import {createReducer} from "redux-act";
import {PlayerPoolFilterStats, StatsSubTab, StatsTopTab} from "modules/enums";

export interface IStat {
	id: PlayerPoolFilterStats;
	name: string;
}

export interface IStatCell {
	id: string;
	name: string;
}

export interface IStatsReducer {
	stats: IStat[];
	statsCentre: {
		[StatsTopTab.Offence]: {
			[StatsSubTab.Passing]: IStatCell[];
			[StatsSubTab.Rushing]: IStatCell[];
			[StatsSubTab.Receiving]: IStatCell[];
		};
		[StatsTopTab.Defence]: IStatCell[];
		[StatsTopTab.Special]: IStatCell[];
	};
}

const initialState = {
	stats: [
		{
			id: PlayerPoolFilterStats.PassTouchdowns,
			name: "player_pool.stats.pass_tds",
		},
		{
			id: PlayerPoolFilterStats.ReceivingTouchdowns,
			name: "player_pool.stats.rec_tds",
		},
		{
			id: PlayerPoolFilterStats.RushingTouchdowns,
			name: "player_pool.stats.rush_tds",
		},
		{
			id: PlayerPoolFilterStats.PassYards,
			name: "player_pool.stats.pass_yds",
		},
		{
			id: PlayerPoolFilterStats.ReceivingYards,
			name: "player_pool.stats.rec_yds",
		},
		{
			id: PlayerPoolFilterStats.RushingYards,
			name: "player_pool.stats.rush_yds",
		},
		{
			id: PlayerPoolFilterStats.Sacks,
			name: "player_pool.stats.sacks",
		},
		{
			id: PlayerPoolFilterStats.DefensiveTackles,
			name: "player_pool.stats.defensive_tackles",
		},
		{
			id: PlayerPoolFilterStats.Interceptions,
			name: "player_pool.stats.interceptions",
		},
		{
			id: PlayerPoolFilterStats.DefensiveTacklesForLoss,
			name: "player_pool.stats.defensive_tackles_for_loss",
		},
		{
			id: PlayerPoolFilterStats.FieldGoalsMade,
			name: "player_pool.stats.field_goals_made",
		},
		{
			id: PlayerPoolFilterStats.FieldGoalPercentage,
			name: "player_pool.stats.field_goal_percentage",
		},
		{
			id: PlayerPoolFilterStats.GamesPlayed,
			name: "player_pool.stats.games_played",
		},
		// {
		// 	id: PlayerPoolFilterStats.GamesStarted,
		// 	name: "player_pool.stats.games_started",
		// },
		{
			id: PlayerPoolFilterStats.AveragePuntYards,
			name: "player_pool.stats.average_punt_yards",
		},
		{
			id: PlayerPoolFilterStats.PuntYards,
			name: "player_pool.stats.punt_yards",
		},
		{
			id: PlayerPoolFilterStats.ReturnTouchdowns,
			name: "player_pool.stats.return_touchdowns",
		},
		{
			id: PlayerPoolFilterStats.SpecialTeamsTackles,
			name: "player_pool.stats.special_teams_tackles",
		},
	],

	statsCentre: {
		/**
		 * Stats from getStatsPlayersList
		 */
		[StatsTopTab.Offence]: {
			[StatsSubTab.Passing]: [
				{id: "passingTouchdowns", name: "pass_tds"}, // Pass touchdowns
				{id: "passingYards", name: "pass_yds"}, // Pass yards
				{id: "passingYardsAverage", name: "avg_pass_yds"}, // average pass yards
				{id: "passingCompletionsPercentage", name: "comp_percent"}, // average pass yards, Comp% is amount of (complete passes / attempted passes) x 100
				{id: "passingInterceptions", name: "int"}, // interceptions
			],
			[StatsSubTab.Rushing]: [
				{id: "rushingTouchdowns", name: "rush_tds"}, // Rush touchdowns
				{id: "rushingYards", name: "rush_yds"}, // rush yards
				{id: "rushingYardsAverage", name: "avg_rush_yds"}, // average rush yards
				{id: "rushingAttempts", name: "push"}, // rushes
			],
			[StatsSubTab.Receiving]: [
				{id: "receivingTouchdowns", name: "rec_tds"}, // Rec touchdowns
				{id: "receivingYards", name: "rec_yds"}, // rec yards
				{id: "receivingYardsAverage", name: "avg_rec_yds"}, // average rec yards
				{id: "targets", name: "tar"}, // targets
				{id: "receivingReceptions", name: "rec"}, // receptions
			],
		},
		[StatsTopTab.Defence]: [
			{id: "tackles", name: "tackles"}, // Tackles
			{id: "sacks", name: "sacks"}, // Sacks
			{id: "fumblesForced", name: "fumbles"}, // Fumbles forced
			{id: "interceptions", name: "int"}, // Interceptions
			{id: "defensiveTouchdowns", name: "def_tds"}, // Def touchdowns
		],
		[StatsTopTab.Special]: [
			{id: "fieldGoalsPct", name: "field_goal"}, // Field goal percentage
			{id: "kickoffReturnsAverage", name: "kickoff"}, // Kickoff return average
			{id: "specialTeamsTackles", name: "special_team"}, // Special teams tackles
			{id: "puntReturnsAverage", name: "punt"}, // Punt return average
			{id: "returnsTouchdowns", name: "return"}, // Return touchdowns
		],
	},
};

export const statsReducer = createReducer<IStatsReducer>({}, initialState);
